import {useContext, useEffect} from 'react'
import {useDBSubscribe} from '../../effects'
import DB from '../../DAL/DB'
import {auth} from '../../Auth'
import {ReducerContext} from '../reducer'

const forms = new DB.Forms()

export default function useGetForms() {
  const {state, dispatch} = useContext(ReducerContext)

  const fo = useDBSubscribe(forms, {filters: [['organization.id', '==', auth.sunkaizenUser.organization.id]]})

  useEffect(
    function () {
      const ft = {...state.filterTypes}
      ft.type.options = fo.map((form) => ({id: form.id, name: form.title}))
      /* this sort with case sensitivity */
      /*
      ft.type.options = Array.from(new Set(ft.type.options)).sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
      */
      /* case insensetive sorting */
      ft.type.options = Array.from(new Set(ft.type.options)).sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });


      dispatch({type: 'filterTypes', value: ft})
    },
    [fo]
  )
}
